import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const UNIVERSAL_SEARCH_EVENT_NAMES = {
  QUERY_BY_W3W: 'query_by_w3w',
  QUERY_BY_MAFID: 'query_by_mafid',
  CLICK_SEARCH_RESULT: 'click_on_search_result',
  QUERY_FROM_SEARCH_BAR: 'query_form_by_role',
};

export const trackQueryByW3W = irpVersion => {
  gspx.trackEvent({
    name: UNIVERSAL_SEARCH_EVENT_NAMES.QUERY_BY_W3W,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Universal Search',
      legacy_name: 'Query by W3W',
      Category: 'What3words',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackQueryByMAFID = irpVersion => {
  gspx.trackEvent({
    name: UNIVERSAL_SEARCH_EVENT_NAMES.QUERY_BY_MAFID,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Universal Search',
      legacy_name: 'Query by MAFID',
      Category: 'MedicAlert',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackClickOnSearchResult = (irpVersion, payloadID, requestID) => {
  gspx.trackEvent({
    name: UNIVERSAL_SEARCH_EVENT_NAMES.CLICK_SEARCH_RESULT,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data Jurisdiction',
      legacy_name: 'Click on search result',
      Category: 'Jurisdiction View',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};

export const trackQueryFromSearchBar = (
  userRoleName,
  irpVersion,
  payloadID,
  requestID,
  serviceType,
  classOfServices,
) => {
  gspx.trackEvent({
    name: UNIVERSAL_SEARCH_EVENT_NAMES.QUERY_FROM_SEARCH_BAR,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Data SearchBar',
      legacy_name: `Query form by ${userRoleName}`,
      Category: 'Query View',
      'Launched date': new Date(),
      irpVersion,
      serviceType,
      classOfServices,
    },
    entities: {
      payload_id: payloadID,
      request_id: requestID,
    },
  });
};
